import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="notfound-page">
      <div className="notfound-glow notfound-glow-1"></div>
      <div className="notfound-glow notfound-glow-2"></div>

      <div className="notfound-card">
        <div className="notfound-code">404</div>

        <h1 className="notfound-title">{t("page_not_found_title")}</h1>

        <p className="notfound-description">
          {t("page_not_found_description")}
        </p>

        <div className="notfound-actions">
          <button
            className="notfound-btn notfound-btn-secondary"
            onClick={() => window.history.back()}
            type="button"
          >
            {t("go_back")}
          </button>

          <button
            className="notfound-btn notfound-btn-primary"
            onClick={() => navigate("/")}
            type="button"
          >
            {t("not_found_go_home")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;